<template>
  <div class="dashboard">
    <v-subheader class="py-0 d-flex justify-space-between rounded-lg">
      <h3>Dashboard</h3>
      <v-spacer/>
      <v-btn color="success" class="ma-1">
        SMS Center
      </v-btn>
      <v-btn color="error" class="ma-1">
        Call  Center
      </v-btn>
    </v-subheader>
    <br>
    <v-row>
      <v-col lg="7" cols="12">
        <v-alert dense text type="success">
          Login Successfully! Welcome to <strong><span class="green--text">Politik<span class="pink--text">.sms</span></span></strong>
        </v-alert>
        <v-row>
          <v-col lg="6" cols="12" v-for="(item,index) in activityLog" :key="index">
            <v-card elevation="2" class="rounded-lg">
              <v-card-text class="d-flex justify-space-between align-center">
                <div>
                  <strong>{{ item.title }}</strong> <br>
                  <span>Last 3 weeks</span>
                </div>
                <v-avatar size="60" :color="item.color" style="border: 3px solid #444">
                  <span style="color: white">{{item.amount}} +</span>
                </v-avatar>
              </v-card-text>
              <v-card-actions class="d-flex justify-space-between">


              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" lg="5">
        <v-card>
          <v-card-title>Activities</v-card-title>
          <v-card-text class="py-0">
            <v-timeline align-top dense>
              <v-timeline-item color="indigo" small>
                <strong>5 Minutes ago</strong>
                <div class="text-caption">
                 Campaign 423 started
                </div>
              </v-timeline-item>
              <v-timeline-item color="green" small>
                <strong>35 Minutes ago</strong>
                <div class="text-caption mb-2">
                Survey 6 Completed
                </div>
              </v-timeline-item>

              <v-timeline-item color="indigo" small>
                <strong>3 days ago</strong>
                <div class="text-caption">
                 100 calls made
                </div>
              </v-timeline-item>
            </v-timeline>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col>
        <v-card>
          <v-card-title class="justify-center">Recent Polls</v-card-title>
          <v-data-table
              :headers="headers"
              :items="desserts"
              :items-per-page="5"
              class="elevation-1"
          >
            <template v-slot:item.action="">
              <v-btn color="success" outlined small shaped >View</v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "Dashboard",
  metaInfo: {
    title: 'Client Dashboard',
  },
  data() {
    return {
      activityLog: [
        {title: 'Total Polls', amount: 50, icon: 'mdi-account', color: 'cyan lighten-3'},
        {title: 'Total Messages', amount: 100, icon: 'mdi-account-group-outline', color: 'green darken-2'},
        {title: 'Total Calls', amount: 52, icon: 'mdi-account-group-outline', color: 'blue-grey darken-1'},
        {
          title: 'Pending Calls',
          amount: 34,
          icon: 'mdi-account-group-outline',
          color: 'deep-orange darken-1'
        },
      ],
      headers: [
        {
          text: 'Area',
          align: 'start',
          sortable: false,
          value: 'name',
        },
        {text: 'SMS Sent', value: 'calories'},
        {text: 'Calls Made', value: 'fat'},
        {text: 'Popularity', value: 'carbs'},
        {text: 'Actions', value: 'action'},
      ],
      desserts: [
        {
          name: 'Kirimari Ward',
          calories: 159,
          fat: 6.0,
          carbs: 24,
          protein: 4.0,
          iron: '1%',
        }
      ],
    }
  },
  methods: {
    onButtonClick(item) {
      console.log('click on ' + item.no)
    }
  }

}
</script>

<style scoped>
.overlap-icon {
  position: absolute;
  top: -33px;
  text-align: center;
  padding-top: 12px;
}
</style>